export const monthFirstDigitMaxValue = 1

// only applied if the first digit is equal to the max value
export const monthSecondDigitMaxValue = 2

export const numberOfDigits = 2